// extracted by mini-css-extract-plugin
module.exports = {"paper":"CropsChart_paper__3VdUr","loader":"CropsChart_loader__2SXx_","circleLoader":"CropsChart_circleLoader__21FWf","circleLoaderIcon":"CropsChart_circleLoaderIcon__2iEMQ"};